export enum ArchitecturalTag {
  BUILD = 'build',
  SPEC = 'spec',
}
